import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const leafWetnessHours: typeof valueTypeRenderers.leafWetnessHours = {
  label: () => unitConverter.leafWetnessHours().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.leafWetnessHours().title(),
      render: (n) => unitConverter.leafWetnessHours(n).valueAsString(),
    }),
}
